module.exports = __webpack_public_path__ + "img/date6-icon.27b190a5.png";